import React, { createContext, useContext } from 'react';
interface RegistrationContextType {
  openPopup: () => void;
}
const RegistrationContext = createContext<RegistrationContextType | undefined>(undefined);
export const RegistrationProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const openPopup = () => {
    window.location.href = '/webinar-mc';
  };
  return <RegistrationContext.Provider value={{
    openPopup
  }} data-id="element-289">
      {children}
    </RegistrationContext.Provider>;
};
export const useRegistration = (): RegistrationContextType => {
  const context = useContext(RegistrationContext);
  if (context === undefined) {
    throw new Error('useRegistration must be used within a RegistrationProvider');
  }
  return context;
};